<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<mat-slide-toggle
	[id]="id"
	[class.large-toggle]="size === 'large'"
	[class.small-toggle]="size === 'small'"
	[checked]="checked"
	[disabled]="isDisabled"
	[required]="required"
	[labelPosition]="materialLabelPosition"
	[tabIndex]="tabIndex"
	[attr.aria-label]="ariaLabel || null"
	(change)="onToggle($event)"
	(blur)="onBlur()"
>
	<ng-content></ng-content>
</mat-slide-toggle>
